module.exports = __webpack_public_path__ + "static/media/GuideSearchPageOS10Step1.14b700e1.gif";